import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// L-103 (2026-10-15): the pages the sidebar hides from Members (Employees, Location Data, Training, Resources Library)
// are also closed to them by address. Same rule as the sidebar: ORG_ADMIN, SUPER_ADMIN, or a super admin.
// Anyone else is sent to the dashboard. The database enforces the same boundary (release 4); this keeps the screen
// honest about it.
interface OrgAdminGuardProps {
  children: React.ReactElement;
}

export const isOrgAdminProfile = (role: string | null | undefined, isSuperAdmin: boolean): boolean =>
  isSuperAdmin || role === 'ORG_ADMIN' || role === 'SUPER_ADMIN';

const OrgAdminGuard: React.FC<OrgAdminGuardProps> = ({ children }) => {
  const { profile, isSuperAdmin, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!profile || !isOrgAdminProfile(profile.role, isSuperAdmin)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default OrgAdminGuard;
